<div class="report-controls" style="display:flex;gap:12px;align-items:center;flex-wrap:wrap">
  <mat-form-field appearance="outline">
    <mat-label>Centre</mat-label>
    <mat-select [formControl]="centreControl">
      <mat-option value="All">All</mat-option>
      <mat-option *ngFor="let c of (centres$ | async)" [value]="c.centreCode">{{ c.centreName }}</mat-option>
    </mat-select>
  </mat-form-field>

  <mat-form-field appearance="outline">
    <mat-label>Date range</mat-label>
    <mat-date-range-input [rangePicker]="rangePicker">
      <input matStartDate placeholder="Start date" [formControl]="startDateControl">
      <input matEndDate placeholder="End date" [formControl]="endDateControl">
    </mat-date-range-input>
    <mat-datepicker-toggle matSuffix [for]="rangePicker"></mat-datepicker-toggle>
    <mat-date-range-picker #rangePicker></mat-date-range-picker>
  </mat-form-field>

  <button mat-mini-fab color="primary" (click)="generateReport()" [disabled]="loading"><mat-icon>search</mat-icon></button>
</div>
<div class="card">
  <div class="ngxTableHeader">
    <ul class="header-buttons-left ms-0 mb-0">
      <li class="dropdown">
                  <h2>Counselling Session Count ( New )</h2>
      </li>
      <li class="dropdown m-l-20">
        <label for="search-input"><i class="material-icons search-icon">search</i></label>
        <input placeholder="Search" id="search-input" type="text" class="browser-default search-field"
               (keyup)='applyFilter($event)' aria-label="Search box">
      </li>
    </ul>
    <ul class="header-buttons mr-2">
<!--      <li>-->
<!--        <button   mat-mini-fab color="primary" (click)="addLog()">-->
<!--          <mat-icon class="col-white" >add</mat-icon>-->
<!--        </button>-->
<!--      </li>-->
      <li>
        <div  class="export-button m-l-10" matTooltip="XLSX" (click)="exportexcel()">
          <img src="assets/images/icons/xlsx.png" alt="" />
        </div>
      </li>
    </ul>
  </div>

<mat-progress-bar *ngIf="loading" mode="indeterminate"></mat-progress-bar>

<table mat-table [dataSource]="dataSource" class="mat-elevation-z8" matSort *ngIf="!loading && dataSource.data.length">

  <!-- Centre Name Column -->
  <ng-container matColumnDef="centreName">
    <th mat-header-cell *matHeaderCellDef> Centre Name </th>
    <td mat-cell *matCellDef="let row"> {{row.centreName}} </td>
  </ng-container>

  <!-- NoOfFamilies -->
  <ng-container matColumnDef="noOfFamilies">
    <th mat-header-cell *matHeaderCellDef> No. of Families </th>
    <td mat-cell *matCellDef="let row"> {{row.noOfFamilies}} </td>
  </ng-container>

  <!-- Individual Sessions -->
  <ng-container matColumnDef="individualSessions">
    <th mat-header-cell *matHeaderCellDef> Individual Sessions </th>
    <td mat-cell *matCellDef="let row"> {{row.individualSessions}} </td>
  </ng-container>

  <!-- Followup Sessions -->
  <ng-container matColumnDef="followupSessions">
    <th mat-header-cell *matHeaderCellDef> Follow-up Sessions </th>
    <td mat-cell *matCellDef="let row"> {{row.followupSessions}} </td>
  </ng-container>

  <!-- Group Sessions -->
  <ng-container matColumnDef="groupSessions">
    <th mat-header-cell *matHeaderCellDef> Group Sessions </th>
    <td mat-cell *matCellDef="let row"> {{row.groupSessions}} </td>
  </ng-container>

  <!-- Assessments -->
  <ng-container matColumnDef="assessments">
    <th mat-header-cell *matHeaderCellDef> Assessments </th>
    <td mat-cell *matCellDef="let row"> {{row.assessments}} </td>
  </ng-container>

  <!-- Total Column -->
  <ng-container matColumnDef="total">
    <th mat-header-cell *matHeaderCellDef> Total </th>
    <td mat-cell *matCellDef="let row"> {{row.total || 0}} </td>
  </ng-container>

  <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
  <tr mat-row *matRowDef="let _row; columns: displayedColumns;"></tr>
</table>

<mat-paginator [pageSizeOptions]="[5, 10, 20]" showFirstLastButtons></mat-paginator>

<div *ngIf="!loading && !dataSource.data.length">No data to display. Select filters and click Search.</div>
</div>
